// removed by extract-text-webpack-plugin
module.exports = {"d2dColorPrimary":"#5AB53C","d2dColorPrimaryLight":"rgba(90,181,60,0.129412)"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/gobal.scss
// module id = Y/e2
// module chunks = 1